import {
  LazyIconPercent,
  LazyIconSparkle,
  LazyIconArrow,
  LazyIconCheck,
  LazyIconChat,
  LazyIconMail,
  LazyIconStar,
  LazyIconStarHollow,
  LazyIconPhone,
  LazyIconStore,
  LazyIconPaymentMethodsAmericanExpress,
  LazyIconPaymentMethodsApplePay,
  LazyIconPaymentMethodsDeCadeaukaart,
  LazyIconPaymentMethodsFlyingBlue,
  LazyIconPaymentMethodsBancontact,
  LazyIconPaymentMethodsBelfius,
  LazyIconPaymentMethodsIdeal,
  LazyIconPaymentMethodsKbc,
  LazyIconPaymentMethodsKlarna,
  LazyIconPaymentMethodsMaestro,
  LazyIconPaymentMethodsMastercard,
  LazyIconPaymentMethodsPayByBank,
  LazyIconPaymentMethodsPaypalIcon,
  LazyIconPaymentMethodsVisa,
  LazyIconDeliveryMethodsBpost,
  LazyIconDeliveryMethodsBpostGreen,
  LazyIconDeliveryMethodsDhl,
  LazyIconSocialMediaFacebook,
  LazyIconSocialMediaFacebookFilled,
  LazyIconSocialMediaInstagram,
  LazyIconSocialMediaInstagramFilled,
  LazyIconSocialMediaTiktok,
  LazyIconSocialMediaTiktokFilled,
  LazyIconSocialMediaWhatsapp,
} from '#components'

export function useStrapiIcons() {
  const icons = {
    LazyIconPercent,
    LazyIconSparkle,
    LazyIconArrow,
    LazyIconCheck,
    LazyIconChat,
    LazyIconMail,
    LazyIconStar,
    LazyIconStarHollow,
    LazyIconPhone,
    LazyIconStore,
    LazyIconPaymentMethodsAmericanExpress,
    LazyIconPaymentMethodsApplePay,
    LazyIconPaymentMethodsDeCadeaukaart,
    LazyIconPaymentMethodsFlyingBlue,
    LazyIconPaymentMethodsBancontact,
    LazyIconPaymentMethodsBelfius,
    LazyIconPaymentMethodsIdeal,
    LazyIconPaymentMethodsKbc,
    LazyIconPaymentMethodsKlarna,
    LazyIconPaymentMethodsMaestro,
    LazyIconPaymentMethodsMastercard,
    LazyIconPaymentMethodsPayByBank,
    LazyIconPaymentMethodsPaypalIcon,
    LazyIconPaymentMethodsVisa,
    LazyIconDeliveryMethodsBpost,
    LazyIconDeliveryMethodsBpostGreen,
    LazyIconDeliveryMethodsDhl,
    LazyIconSocialMediaFacebook,
    LazyIconSocialMediaFacebookFilled,
    LazyIconSocialMediaInstagram,
    LazyIconSocialMediaInstagramFilled,
    LazyIconSocialMediaTiktok,
    LazyIconSocialMediaTiktokFilled,
    LazyIconSocialMediaWhatsapp,
  }

  function loadIcon(icon: string) {
    if (!icon) {
      return 'div'
    }

    const base = 'LazyIcon'
    const paymentBase = base + 'PaymentMethods'
    const shippingBase = base + 'DeliveryMethods'
    const socialBase = base + 'SocialMedia'

    const iconName = usePascal(icon)

    switch (iconName) {
      case 'ArrowLeft':
      case 'ArrowRight':
        return LazyIconArrow
      case 'Paypal':
        return LazyIconPaymentMethodsPaypalIcon
      case 'Email':
        return LazyIconMail
      default:
        if (icons?.[base + iconName] || icons?.[paymentBase + iconName] || icons?.[shippingBase + iconName] || icons?.[socialBase + iconName]) {
          return icons[base + iconName] || icons[paymentBase + iconName] || icons[shippingBase + iconName] || icons?.[socialBase + iconName]
        }
        console.warn('Icon "' + icon + '" not found as: ', base + iconName, paymentBase + iconName, socialBase + iconName)
        return 'div'
    }
  }

  return {
    loadIcon,
  }
}
